
import React from 'react';
import { Backdrop, Button } from '@mui/material';
import { Box } from "@mui/material";
import './SignUpCongragulations.css';

const SignUpCongragulations = ({ loading }) => {
   
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 9999,
                backgroundColor: 'rgba(0, 0, 0, 0.8)', // Set opacity to 0.5
            }}
            open={loading} // Show or hide the loading screen based on the "loading" prop
        >
            <Box sx={{
                textAlign: 'center',
            }}>
                <div style={{ width: '500px', height: '100px' }}>
                    <div >
                        <h1>Your account has been created successfully.</h1>
                        <p>Please contact your administrator for account activation.</p>
                        <Button variant="contained" sx={{backgroundColor:"#3f7c80",padding:"10px 20px", "&:hover": { backgroundColor: "#5D969A" }}} onClick={() => window.location.href = '/signin'}
                        >
                            Go Login Page
                        </Button>
                    </div>
                </div>
            </Box>
        </Backdrop>
    );
};

export default SignUpCongragulations;
